import React from 'react';
import PropTypes from 'prop-types';
import { ProfileSettingsConfig } from '@Constants/rx-user/constants';
import { RadioButtonGroup } from '@els/els-react--radio-button';
import ProfileSettingsAccordionItem from '@Pages/ProfileSettings/Components/ProfileSettingsAccordionItem';

import './StructureEditor.scss';

function StructureEditor({ title, options = [], currentOption, onChange = () => {}, onSave = () => {}, onClose = () => {} }) {
  const handleChange = (value) => {
    onChange(null, value);
  };
  return (
    <ProfileSettingsAccordionItem
      onClose={onClose}
      onSave={onSave}
      label={ProfileSettingsConfig.Labels.selectEditor}
      dataE2E="profile-settings-accordion-row-structure-editor"
      title={title}
      value={title}
      validateOnSave>
      <fieldset className="structure-editor__fieldset">
        <legend className="sr-only">{ProfileSettingsConfig.Labels.selectEditor}</legend>
        {options.map((option) => {
          const key = `${option.name}-${option.value}`;
          return (
            <div key={key} className="search-drawing1 clearfix">
              {option.type === 'radio' && (
                <RadioButtonGroup.Option
                  id={key}
                  className="structure-editor__radio-option"
                  name={option.name}
                  label={option.title}
                  value={option.value}
                  disabled={option.disabled}
                  checked={currentOption === option.value}
                  onChange={() => handleChange(option.value)}
                  aria-label={`Search this structure ${option?.title?.toLowerCase?.() || ''}`}
                />
              )}
            </div>
          );
        })}
      </fieldset>
    </ProfileSettingsAccordionItem>
  );
}

StructureEditor.propTypes = {
  options: PropTypes.array,
  currentOption: PropTypes.string,
  title: PropTypes.string,
  onChange: PropTypes.func,
  onSave: PropTypes.func,
  onClose: PropTypes.func,
};

export default StructureEditor;
